import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import Caption from 'LuxKit/Typography/Caption'
import useAgentHubBookingOnboardingNeedHelp from './useAgentHubBookingOnboardingNeedHelp'

function AgentHubBookingOnboardingNeedHelpButton() {
  const { canReplay, label, start } = useAgentHubBookingOnboardingNeedHelp()

  if (!canReplay) {
    return null
  }

  return (
    <CSSBreakpoint min="tablet">
      <TextButton kind="tertiary" variant="default" onClick={start}>
        <Caption variant="medium" weight="bold">
          {label}
        </Caption>
      </TextButton>
    </CSSBreakpoint>
  )
}

export default AgentHubBookingOnboardingNeedHelpButton
